import React from 'react';
import Card from '../../components/shared/card/Card';
import FlexItem from '../../components/shared/flex/FlexItem';
import FlexParent from '../../components/shared/flex/FlexParent';
import { getJobWithCompany } from '../../helpers/format';
import {
  ListItemLogo,
  ListItemShadow,
  ListItemTitle,
  ListItemSubTitle
} from '../../components/shared/ListItem';
import Star from '../../components/shared/fav/Star';
import styled from 'styled-components';

const Online = styled.div`
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background-color: #7ed321;
  position: absolute;
  right: 8px;
  bottom: 2px;
  border: 2px solid white;
`;

class ScannedAttendeeItem extends React.Component {
  onClickAttendee = () => {
    const { attendee, matchParams, history } = this.props;
    const { appId, eventId } = matchParams;

    const attendeeDetailsUrl = `/apps/${appId}/events/${eventId}/scanned-attendees/attendee/${attendee.id}`;
    history.push(attendeeDetailsUrl);
  };

  render() {
    const { t, theme, attendee, user, matchParams, isOnline, withoutFav, whosHere } = this.props;
    const { avatar_url, name, job_title, company, country_name } = attendee;
    const attendeeDescription = getJobWithCompany(job_title, company, country_name);

    const shouldShowStar = !withoutFav && attendee.id !== user?.id && whosHere?.is_starable;

    if (attendee.is_incognito) {
      return null;
    }

    return (
      <Card margin={'0 10px 20px'} padding={'10px'} onClick={this.onClickAttendee}>
        <FlexParent justifyContent={'space-between'}>
          <FlexItem position={'relative'}>
            {avatar_url && (
              <React.Fragment>
                <ListItemLogo src={avatar_url} alt={name} />
                <ListItemShadow />
              </React.Fragment>
            )}
            {isOnline && <Online />}
          </FlexItem>

          <FlexItem grow={1}>
            <ListItemTitle>
              {attendee.id === user.id ? t('me') : attendee.name}{' '}
              {this.props.admin ? `(${t('admin')})` : ''}
            </ListItemTitle>
            <ListItemSubTitle>{attendeeDescription}</ListItemSubTitle>
          </FlexItem>

          <FlexItem alignSelf={'center'}>
            {shouldShowStar && (
              <Star 
                {...{ theme }} 
                model={attendee} 
                type={'attendee'} 
                matchParams={matchParams}
                agendaIsStarable={whosHere?.is_starable}
              />
            )}
          </FlexItem>
        </FlexParent>
      </Card>
    );
  }
}

export default ScannedAttendeeItem;
